<nav class="toolbar" [ngStyle]="{ background: backgroungColor }">
	<a class="toolbar__logo" href="http://www.cajamorelia.com.mx" target="_blank">
		<picture>
			<source media="(min-width:451px)" [srcset]="desktopImageSrc" />
			<img [src]="mobileImageSrc" />
		</picture>
	</a>

	<div class="toolbar__actions">
		<ng-content></ng-content>
	</div>
	<button
		*ngIf="showBackButton"
		class="toolbar__back-button"
		(click)="onBack()">
		<i class="bi bi-arrow-left"></i>
	</button>
</nav>
